import React from 'react';
import styled from 'styled-components';
import Background from '../assets/images/bg.png';

import CustomForm from '../components/CustomForm';
import { MobileWidth, SmallMobileWidth, pmBlack } from '../sharedData/Constants';
import FormText from '../components/FormText';
import PageFormData from '../sharedData/PageFormData';
import GeneralContext from '../contexts/GeneralContext';
import PmwebLogo from '../assets/images/somos-crm-1.png';

const PageForm = () => {
    return(
        <StyledView>
            <StyledFlexContainer> 
                <GeneralContext.Provider value={PageFormData}>
                    <StyledColumnContainer>
                        <a rel="noreferrer" target="_blank" href='https://www.pmweb.com.br'>
                            <StyledPmwebLogo src={PmwebLogo} alt="Logo Pmweb" />    
                        </a>	
                        <StyledFlexContainer>
                            <FormText/>
                            <CustomForm/>
                        </StyledFlexContainer>
                    </StyledColumnContainer>
                </GeneralContext.Provider>
            </StyledFlexContainer>
        </StyledView>
    );
}

const StyledPmwebLogo = styled.img`
    padding: 0 72px;
    @media screen and (max-width: ${MobileWidth}){
        padding: 0 0;
        width: 124px;
        height: 100px;
        margin-bottom: 47px;
    }
`;

const StyledColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: baseline;
    @media screen and (max-width: ${MobileWidth}){
        align-items: center;
    }
`;

const StyledFlexContainer = styled.div`
    display: flex;
    padding: 0 72px;
    justify-content: space-between;
    @media screen and (max-width: ${MobileWidth}) {
        flex-direction: column;
        align-items: center;
        min-width: unset;
        padding: 0 0;
    }
`;

const StyledView = styled.div`
    position: relative;
    background-color: ${pmBlack};
    display: flex;
    padding: 67px 72px 73px;
    align-items: center;
    justify-content: center;
    z-index: 12;
    background-image: url(${Background});
    background-size: cover;
    background-repeat: no-repeat;
    @media screen and (max-width: ${MobileWidth}) {
        padding: 32px 0;
    }
    @media screen and (max-width: ${SmallMobileWidth}){
        padding: 32px 24px;
    }
    @media screen and (min-height: 1000px){
        height: calc(100vh - 172px);
    }
`;

export default PageForm;